import { object, string } from "yup";

export interface PolicyNotesForm {
  content: string;
}

export const defaultValues: PolicyNotesForm = {
  content: "",
};

export const validation = object({
  content: string()
    .max(500)
    .trim()
    .notOneOf([""], "Cannot submit an empty note."),
});
